module.exports = __webpack_public_path__ + "static/media/css-template.dd3e7630.txt";